import Vue from 'vue'
import Router from 'vue-router'
import Admin from 'Core/src/views/Admin2.vue'
import Login from 'Core/src/views/Login.vue'
import Analyze from 'Core/src/views/Analyze2.vue'
import MongoDBCharts from 'Core/src/views/MongoDBCharts.vue'
import MongoDBDash from 'Core/src/views/MongoDBDash.vue'
import Play from 'Core/src/views/Play2.vue'
import NotFound from 'Core/src/views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,

  mode: 'history',

  routes: [
    {
      path: '/index.html',
      component: Admin
    },
    {
      path: '/',
      name: 'admin',
      component: Admin
    },
    {
      path: '/survey/:sid',
      name: 'admin/sid',
      component: Admin
    },
    {
      path: '/login',
      name: 'login',
      component: Login

    },
    {
      path: '/admin',
      redirect: '/'
    },
    {
      path: '/charts/:sid',
      name: 'admin/charts',
      component: MongoDBCharts
    },
    {
      path: '/mongo-dash/:sid',
      name: 'admin/mongo-dash',
      component: MongoDBDash
    },
    {
      path: '/survey/:sid/analyze',
      name: 'admin/analyze',
      component: Analyze
    },
    {
      path: '/survey/:sid/play',
      name: 'admin/play',
      component: Play
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }
  ]
})

export default router
